module.exports = __webpack_public_path__ + "static/media/result-intro.3d0df65c.wav";